import { render, staticRenderFns } from "./c_txt_tab.vue?vue&type=template&id=e16a423e&scoped=true"
import script from "./c_txt_tab.vue?vue&type=script&lang=js"
export * from "./c_txt_tab.vue?vue&type=script&lang=js"
import style0 from "./c_txt_tab.vue?vue&type=style&index=0&id=e16a423e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16a423e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e16a423e')) {
      api.createRecord('e16a423e', component.options)
    } else {
      api.reload('e16a423e', component.options)
    }
    module.hot.accept("./c_txt_tab.vue?vue&type=template&id=e16a423e&scoped=true", function () {
      api.rerender('e16a423e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_txt_tab.vue"
export default component.exports